'use client';

import { useContext } from 'react';

import { BrandContext } from '../BrandProvider/BrandContext';
import type { Brand } from '../types/brand';

/** The current brand. Throws outside `BrandProvider`, so a missing provider shows up at once. */
export function useBrand(): Brand {
    const brand = useContext(BrandContext);

    if (!brand) {
        throw new Error('useBrand() must be used inside <BrandProvider>.');
    }

    return brand;
}
